/**
 * Azure Best Practice: Centralized constants for consistent naming across the application
 */

// Standard internal prayer names (used in code)
export const PRAYER_TYPES = {
  FAJR: "fajr",
  DHUHR: "dhuhr",
  ASAR: "asar",
  MAGHRIB: "maghrib",
  ISHA: "isha", // Standardize on "isha" for internal use
} as const;

// Standard prayer time properties mapped to PrayerTimes interface
export const PRAYER_TIME_KEYS = {
  [PRAYER_TYPES.FAJR]: {
    BEG: "BegFajr",
    JAM: "JamFajr",
  },
  [PRAYER_TYPES.DHUHR]: {
    BEG: "BegDhuhr",
    JAM: "JamDhuhr",
  },
  [PRAYER_TYPES.ASAR]: {
    BEG: "BegAsar",
    JAM: "JamAsar",
  },
  [PRAYER_TYPES.MAGHRIB]: {
    BEG: "BegMaghrib", // Primary key (independent field)
    BEG_ALT: "Sunset", // Fallback key
    JAM: "JamMaghrib",
  },
  [PRAYER_TYPES.ISHA]: {
    BEG: "BegEsha", // Primary key
    BEG_ALT: "BegIsha", // Alternative key
    JAM: "JamEsha", // Primary key
    JAM_ALT: "JamIsha", // Alternative key
  },
} as const;

// Ordered array for standard prayer sequence
export const PRAYER_SEQUENCE = [
  PRAYER_TYPES.FAJR,
  PRAYER_TYPES.DHUHR,
  PRAYER_TYPES.ASAR,
  PRAYER_TYPES.MAGHRIB,
  PRAYER_TYPES.ISHA,
] as const;
